export const appHead = {"meta":[{"name":"viewport","content":"width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no"},{"charset":"utf-8"},{"name":"description","content":"Поздравь легенду российского футбола и выиграй эксклюзивный приз"},{"property":"og:type","content":"website"},{"property":"og:url","content":"https://specials.sports.ru/akinfeev-birthday/"},{"property":"og:locale","content":"ru_RU"},{"property":"og:title","content":"Юбилей Игоря Акинфеева"},{"property":"og:description","content":"Поздравь легенду российского футбола и выиграй эксклюзивный приз"},{"property":"og:image","content":"https://specials-dumpster.sports.ru/dumpster/cf3a9a45-6d1f-46ec-8c9b-afcd08f95442.webp"},{"property":"og:image:width","content":"1200"},{"property":"og:image:height","content":"630"},{"name":"twitter:image","content":"https://specials-dumpster.sports.ru/dumpster/cf3a9a45-6d1f-46ec-8c9b-afcd08f95442.webp"},{"name":"twitter:card","content":"summary_large_image"}],"link":[{"rel":"shortcut icon","href":"/favicon.ico"},{"rel":"apple-touch-icon","sizes":"180x180","href":"/apple-touch-icon-180x180.png"}],"style":[],"script":[{"innerHTML":"\n          (function() {\n            const hash = window.location.hash;\n            const isTelegramMiniApp = Boolean(hash && hash.includes('tgWebAppData'));\n\n            if(isTelegramMiniApp) {\n              const isSportsRuSpecial = window.location.href.includes('www.sports.ru/special/');\n\n              // redirect from www.sports.ru to m.sports.ru\n              if (window.location.hostname === 'www.sports.ru' && !isSportsRuSpecial) {\n                window.location.href = window.location.href.replace('www.sports.ru', 'm.sports.ru');\n              }\n            }\n\n            const isSessionAlreadySet = Boolean(sessionStorage.getItem('is-telegram-mini-app'));\n\n            if (!isSessionAlreadySet) {\n              sessionStorage.setItem('is-telegram-mini-app', isTelegramMiniApp.toString());\n            }\n\n            if (!isTelegramMiniApp) return;\n\n            const params = new URLSearchParams(window.location.search);\n            \n            // Если уже есть utm_source, то не трогаем\n            if (params.has('utm_source')) {\n              return;\n            }\n\n            let utmSource = 'tg_inapp';\n\n            // Проверяем tgWebAppStartParam если есть\n            if (params.has('tgWebAppStartParam')) {\n              const tgWebAppStartParam = params.get('tgWebAppStartParam') || '';\n              const startParams = tgWebAppStartParam.split('__');\n              const utmParam = startParams.find(function(p) { return p.startsWith('utm_'); });\n              if (utmParam) {\n                utmSource = utmParam.slice(4);\n              }\n            }\n\n            const url = new URL(window.location.href);\n            if (url.searchParams.get('utm_source') !== utmSource) {\n              url.searchParams.set('utm_source', utmSource);\n              history.replaceState(null, '', url.toString());\n            }\n          })();"}],"noscript":[],"htmlAttrs":{"lang":"ru"},"viewport":"width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no","title":"Юбилей Игоря Акинфеева"}

export const appPageTransition = {"name":"page","mode":"out-in"}

export const appLayoutTransition = {"name":"page","mode":"out-in"}

export const appBaseURL = "/"

export const appBuildAssetsDir = "/_nuxt/"

export const appCdnURL = ""

export const appViewTransition = false

export const appKeepalive = false

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const appRootAttrs = {"id":"__nuxt"}

export const appTeleportTag = "div"

export const appTeleportId = "teleports"

export const appTeleportAttrs = {"id":"teleports"}

export const appSpaLoaderTag = "div"

export const appSpaLoaderAttrs = {"id":"__nuxt-loader"}

export const renderJsonPayloads = true

export const componentIslands = true

export const payloadExtraction = false

export const cookieStore = true

export const appManifest = true

export const remoteComponentIslands = false

export const selectiveClient = false

export const devPagesDir = null

export const devRootDir = null

export const devLogs = false

export const nuxtLinkDefaults = {"componentName":"NuxtLink","prefetch":true,"prefetchOn":{"visibility":true}}

export const asyncDataDefaults = {"deep":false}

export const fetchDefaults = {}

export const vueAppRootContainer = '#__nuxt'

export const viewTransition = false

export const appId = "nuxt-app"

export const outdatedBuildInterval = 3600000

export const multiApp = false

export const chunkErrorEvent = "vite:preloadError"

export const crawlLinks = false

export const spaLoadingTemplateOutside = true

export const purgeCachedData = true

export const granularCachedData = true

export const pendingWhenIdle = false

export const alwaysRunFetchOnKeyChange = false